export type RouteId = "viewer" | "drawer" | "tools" | "docs";

export const ROUTES: Array<{ id: RouteId; hash: string; label: string }> = [
  { id: "viewer", hash: "#viewer", label: "Viewer" },
  { id: "drawer", hash: "#drawer", label: "Drawer" },
  { id: "tools", hash: "#tools", label: "Tools" },
  { id: "docs", hash: "#docs", label: "Docs" }
];

export function getCurrentRoute(): RouteId {
  const route = window.location.hash.replace("#", "") as RouteId;
  return ROUTES.some((item) => item.id === route) ? route : "viewer";
}
